import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    overflowY: 'hidden',
    display: 'grid',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
    [theme.breakpoints.only('md')]: {
      gridTemplateColumns: '1fr 2fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '4fr 10fr',
    },
  },
  wrapper: {
    width: '100%',
    backgroundColor: 'white',
    paddingLeft: 4,
    paddingRight: 4,
    [theme.breakpoints.down('md')]: {
      minHeight: '85vh',
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4),
    },
  },
  leftBox: {
    display: 'grid',
    justifyItems: 'center',
    alignContent: 'space-around',
    height: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover, 50%',
    backgroundPosition: 'bottom',
    background: theme.palette.layout.main,
    padding: `${theme.spacing(10)} ${theme.spacing(4)}`,

    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
      height: 'fit-content',
      borderTopRightRadius: 0,
    },
  },
  image: {
    maxHeight: '100%',
    height: 'auto',
    maxWidth: '15vw',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '180px',
    },
  },
  text: {
    color: theme.palette.common.white,
    textAlign: 'justify',
    fontFamily: 'Raleway',
    fontWeight: 400,
  },
}))

export default styles
